import { createFileRoute, Outlet } from '@tanstack/react-router';
import { HoursScheduleContextProvider } from '../../../../features/hours/schedule-context/hours-schedule-context';

export const Route = createFileRoute('/_app/_clearing-core/hours/_hours')({
  component: HoursContainer,
});

function HoursContainer() {
  return (
    <HoursScheduleContextProvider>
      <Outlet />
    </HoursScheduleContextProvider>
  );
}
